export default __webpack_public_path__ + "static/media/CNo.39-4.f4ccb013.jpg";